import React from 'react';
import PropTypes from 'prop-types';
import { withI18n } from 'spa/Components/Context';
import Input, { InputType } from '@urbanmassage/component-library/lib/Input/Input';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

const MAX_FROM_CHARACTERS = 28;

const GiftCardBuyRecipientPostal = ({
  handleRecipientChange,
  recipient,
}, {i18n}) => {
  const handleOnChange = (e) => {
    handleRecipientChange(e);
  };

  return (
    <div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} onChange={handleOnChange} value={recipient.address} name="address" required label={i18n._x('Recipient\'s street address', 'Gifts page form')} placeholder={i18n._x('Type street address', 'Gifts page form')} />
      </div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} onChange={handleOnChange} value={recipient.city} name="city" required label={i18n._x('Recipient\'s city', 'Gifts page form')} placeholder={i18n._x('Type city', 'Gifts page form')} />
      </div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} onChange={handleOnChange} value={recipient.postcode} name="postcode" required label={i18n._x('Recipient\'s postcode', 'Gifts page form')} placeholder={i18n._x('Type postcode', 'Gifts page form')} />
      </div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} onChange={handleOnChange} value={recipient.name} name="name" required label={i18n._x('Recipient\'s name', 'Gifts page form')} placeholder={i18n._x('To', 'Gifts page form')} />
      </div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} onChange={handleOnChange} value={recipient.from} name="from" required label={i18n._x('From', 'Gifts page form')} placeholder={i18n._x('Your name', 'Gifts page form')} maxLength={MAX_FROM_CHARACTERS} />
        <Typography
          variant={TypeVariants.body}
          theme="mediumBody"
        >
          {i18n._x('Maximum number of characters: %(maxChars)s', 'Gifts page form', {
            maxChars: MAX_FROM_CHARACTERS,
          })}
        </Typography>
      </div>
    </div>
  );
};

GiftCardBuyRecipientPostal.propTypes = {
  handleRecipientChange: PropTypes.func.isRequired,
  recipient: PropTypes.object.isRequired,
};

export default withI18n(GiftCardBuyRecipientPostal);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardBuyRecipientPostal.jsx